<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
  <mat-toolbar color="primary" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;" class="toolbar-over-card">
    <div *ngIf="currentCase" class="ellipsis" style="padding-right: 20px;">
      {{currentCase.caseName}}
    </div>
    <mat-menu #appMenu="matMenu">
      <a *ngIf="isNotLimited()" routerLink="/case/uploads" mat-menu-item>Uploads</a>
      <a *ngIf="isAccountAdmin()" routerLink="/discovery/review-sets" mat-menu-item>Review</a>
      <a *ngIf="isNotLimited()" routerLink="/discovery/production-job" mat-menu-item>Production</a>
    </mat-menu>
    <div style="box-sizing: border-box; display: flex; place-content: flex-end space-between; align-items: center;">
      <button routerLink="/select-case" mat-button>Switch Case</button>
      <button *ngIf="showEdit()" mat-icon-button routerLink="{{getEditLink()}}">
        <mat-icon>edit</mat-icon>
      </button>
      <button *ngIf="showMenu" mat-icon-button [matMenuTriggerFor]="appMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; overflow-y: auto;">
    <mat-card>
      <mat-card-content class="content">
        <div *ngIf="caseDetails" style="place-content: stretch flex-start; align-items: stretch; flex-flow: row wrap; box-sizing: border-box; display: flex;">
          <ng-container *ngFor="let detail of caseDetails">
            <div style="flex: 1 1 calc(50% - 32px); box-sizing: border-box;" class="cell">
              <div class="title">{{detail.title}}</div>
              <div *ngIf="!detail.checked">{{detail.value}}</div>
              <mat-icon *ngIf="detail.checked">checked</mat-icon>
            </div>
          </ng-container>
        </div>
      </mat-card-content>
      <mat-card-actions style="display: flex;">
        <div>
          <img *ngIf="!isDarkMode()" class="maincontent_imgLexbeLogo" style="margin-left:27px" height="30" src="/assets/images/lexbe-logo.svg">
          <img *ngIf="isDarkMode()" class="maincontent_imgLexbeLogo" style="margin-left:27px" height="30" src="/assets/images/lexbe-logo-dark-theme-3.svg">
        </div>
        <div style="flex: 1 1 0%; box-sizing: border-box;"></div>
        <div *ngIf="isNotLimited(); else limitedUser">
          <a routerLink="/review/browse" mat-button color="primary">Browse</a>
        </div>
        <ng-template #limitedUser>
          <a *inRole="[roles.DocReviewFeatureSet]" routerLink="/discovery/review-sets" mat-button color="primary">Review Sets</a>
        </ng-template>
      </mat-card-actions>
    </mat-card>

    <div *ngIf="(featureConfigService.featureConfig$ | async)?.enableFeatureSurvey" style="place-content: center center; align-items: center; flex-direction: row; box-sizing: border-box; 
    display: flex; gap: 4px; margin-top: 4px; font-size: 13px;">
      <span>Take our Survey and Help Guide Lexbe's Development!</span>
      <span>
        <a href="https://zfrmz.com/R9RVRXzCIZ6sklHmaw7n?UserId={{userId}}" target="_blank">Click Here</a>
      </span>
    </div>

  </div>
</div>
